export const v2MenuItemSizeClass = {
    small: 'ov-menu-item--sm',
    large: 'ov-menu-item--lg',
};
export const v2MenuItemDangerClass = 'ov-menu-item--danger';
/** Marks the Menu paper a `Select` opens, so its rows read as picker options rather than actions. */
export const v2SelectMenuPaperClass = 'ov-menu--select';
/** Marks an Autocomplete listbox whose picked row shows a check, so that row drops the selected tint. */
export const v2CheckListboxClass = 'ov-listbox--check';
